import { HttpError } from "@/src/common/services/api-error";
import { handleSessionExpired, tryRefreshSession } from "@/src/common/services/http.service";
import { getAccessToken } from "@/src/common/services/token-store.service";

const attemptPut = async (url: string, file: File): Promise<Response> => {
	const accessToken = await getAccessToken();
	const headers: Record<string, string> = { "content-type": file.type };
	if (accessToken) {
		headers.authorization = `Bearer ${accessToken}`;
	}
	return fetch(url, { method: "PUT", headers, body: file });
};

export const putBinary = async (url: string, file: File): Promise<Response> => {
	let response = await attemptPut(url, file);
	if (response.status === 401 && (await tryRefreshSession())) {
		response = await attemptPut(url, file);
	}
	if (!response.ok) {
		if (response.status === 401) {
			await handleSessionExpired();
		}
		const value: unknown = await response.json().catch(() => null);
		throw new HttpError(response.status, value);
	}
	return response;
};
